export default __webpack_public_path__ + "static/media/model.c5dd2c63.jpg";